import { MapPin, Phone } from "lucide-react";
import { ADDRESS, PHONE_DISPLAY, PHONE_TEL } from "./data";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Menu", href: "#menu" },
  { label: "Reviews", href: "#reviews" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#C97B5F]/15 bg-[#2E2114] pb-28 pt-14 sm:pb-14">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 sm:grid-cols-3 sm:px-6">
        <div>
          <a href="#home" data-testid="footer-brand-logo" className="flex items-center">
            <span className="font-cinzel text-lg font-bold tracking-wide text-[#F5E9D2]">
              Curry <span className="text-gold-gradient">Story</span>
            </span>
          </a>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#9A8A6E]">
            Authentic Indian dining in Chapel Hill. Fresh spices, clay tandoor and recipes passed down with love.
          </p>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-[#D4A359]">Explore</h3>
          <ul className="mt-4 space-y-2.5">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm text-[#9A8A6E] transition-colors duration-200 hover:text-[#D4A359]"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-[#D4A359]">Contact</h3>
          <ul className="mt-4 space-y-3 text-sm text-[#9A8A6E]">
            <li className="flex items-start gap-2.5">
              <MapPin size={15} className="mt-0.5 shrink-0 text-[#D4A359]/70" /> {ADDRESS}
            </li>
            <li>
              <a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-2.5 transition-colors duration-200 hover:text-[#D4A359]">
                <Phone size={15} className="shrink-0 text-[#D4A359]/70" /> {PHONE_DISPLAY}
              </a>
            </li>
            <li className="text-[#9A8A6E]">Open daily from 4:30 PM</li>
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-6xl border-t border-[#C97B5F]/10 px-4 pt-6 sm:px-6">
        <p className="text-center text-xs text-[#9A8A6E]">
          © {new Date().getFullYear()} Curry Story Indian Restaurant · Chapel Hill, Brisbane · All rights reserved
        </p>
      </div>
    </footer>
  );
}
